import { render } from "./batchAllOrderInfoDialog.vue?vue&type=template&id=1a9ed0e5&scoped=true"
import script from "./batchAllOrderInfoDialog.vue?vue&type=script&lang=js"
export * from "./batchAllOrderInfoDialog.vue?vue&type=script&lang=js"

import "./batchAllOrderInfoDialog.vue?vue&type=style&index=0&id=1a9ed0e5&lang=scss&scoped=true"

import exportComponent from "D:\\project\\admin-system3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a9ed0e5"]])

export default __exports__